/**
 * Starts playback on a media element, swallowing the rejection autoplay policies produce. jsdom
 * returns undefined from play(), hence the runtime guard even though the DOM types say Promise.
 */
export function safePlay(element: HTMLMediaElement): void {
  const playback: unknown = element.play();
  if (playback instanceof Promise) {
    playback.catch(() => undefined);
  }
}
